import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "container py-5",
  style: {"min-height":"500px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 2,
  class: "mb-5"
}
const _hoisted_4 = { class: "text-subtitle-1" }
const _hoisted_5 = { class: "text-subtitle-2" }

import { ref, onMounted } from 'vue';
import { backendApi, AxiosError } from '@/http';
import { useGlobalStore, useConfigStore } from '@/stores';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { $t } from '@/i18n';

// interfaces
import { MemberType, ResponsibilityType, TeamType } from '@/composables/types';

// components
import PageTitle from '@/components/PageTitle.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamPage',
  setup(__props) {

const $route = useRoute();
const globalStore = useGlobalStore();
const configStore = useConfigStore();
const pageTitleRef = ref();

const team = ref<TeamType>({
  nameAr: '',
  nameEn: '',
  membersTitleAr: '',
  membersTitleEn: '',
  descriptionAr: '',
  descriptionEn: '',
  members: [] as MemberType[],
  responsibilities: [] as ResponsibilityType[],
} as TeamType);

async function getTeam() {
  try {
    const result = await backendApi.get(`teams/${$route.params['id']}`);
    team.value = result.data.data;
  } catch (error: unknown) {
    const message =
      error instanceof AxiosError && error.response?.data.message
        ? error.response.data.message
        : $t('FAILED_TO_LOAD_DATA');
    console.log(message);
    team.value = {} as TeamType;
  }
}

onMounted(async () => {
  await getTeam();
  globalStore.createVisit(
    $route.path,
    configStore.stringLang(team.value.nameAr, team.value.nameEn)
  );
  pageTitleRef.value.pageTitle = configStore.stringLang(
    team.value.nameAr ?? '',
    team.value.nameEn ?? ''
  );
});

watch(
  () => $route.params['id'],
  async () => {
    await getTeam();
    pageTitleRef.value.pageTitle = configStore.stringLang(
      team.value.nameAr,
      team.value.nameEn
    );
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_WebsiteLayout = _resolveComponent("WebsiteLayout")!

  return (_openBlock(), _createBlock(_component_WebsiteLayout, null, {
    content: _withCtx(() => [
      _createVNode(PageTitle, {
        ref_key: "pageTitleRef",
        ref: pageTitleRef,
        "page-title": _unref(configStore).stringLang(team.value.nameAr, team.value.nameEn)
      }, null, 8, ["page-title"]),
      _createElementVNode("div", _hoisted_1, [
        (team.value.responsibilities && team.value.responsibilities.length > 0)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_unref($t)('TEAM_RESPONSIBILITIES')), 1))
          : _createCommentVNode("", true),
        (team.value.responsibilities && team.value.responsibilities.length > 0)
          ? (_openBlock(), _createBlock(_component_v_list, {
              key: 1,
              lines: "one",
              style: {"background-color":"#ffffff00"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.value.responsibilities, (responsibility, index) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: index,
                    title: 
              _unref(configStore).stringLang(
                responsibility.arabic,
                responsibility.english
              )
            ,
                    "prepend-icon": "mdi-check-bold"
                  }, null, 8, ["title"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_divider, { class: "my-5" }),
        (team.value.members && team.value.members.length > 0)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_unref(configStore).stringLang(team.value.membersTitleAr, team.value.membersTitleEn)), 1))
          : _createCommentVNode("", true),
        (team.value.members && team.value.members.length > 0)
          ? (_openBlock(), _createBlock(_component_v_row, { key: 3 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.value.members, (member, index) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    key: index,
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        style: {"text-align":"center"},
                        class: "pa-2",
                        height: "320"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_avatar, {
                            color: "grey",
                            size: "150"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_img, {
                                cover: "",
                                src: (member.image as string)
                              }, null, 8, ["src"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(configStore).stringLang(member.nameAr, member.nameEn)), 1),
                              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(configStore).stringLang(member.roleAr, member.roleEn)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})